module.exports = __webpack_public_path__ + "static/icnz-b85319a4f9fcfd270651c499e104fc78.png";